/**
 * Enum.ts
 * This component is used to define common variables that will be utilized throughout the project.
 */

export enum eWARRANTY_STATUS {
  IN_WARRANTY = 1,
  OUT_OF_WARRANTY = 2,
  IN_WARRANTY_CLAIMED = 3,
  IN_WARRANTY_NOT_CLAIMED = 4,
}
export enum eOUTPUT_STATUS {
  GREEN = 1,
  RED = 2,
}
export enum eEXCEL_STATUS {
  PRESENT = 1,
  NOT_PRESENT = 2,
}

// Enums for Table Type
export enum eTableType {
  ROW = 1,
  COLUMN = 2,
}

export enum eLoginType {
  PASSWORD = 1,
  OTP = 2,
}

// Constants for Input Lengths
export const INPUT_LENGTH = {
  PASSWORD_LENGTH: 20,
  EMAIL_LENGTH: 40,
  BASIC_LENGTH: 30,
  DISPLAY_LENGTH: 15,
  ADDRESS_LENGTH: 80,
  PINCODE_LENGTH: 10,
};

export enum eOVERALLISTSTATUS {
  NOT_SCANNED = 1,
  SCANNED_WAITING_EVAL = 2,
  EVAL_L1 = 3,
  EVAL_L2 = 4,
  TEAR_DOWN = 5,
  NO_FAULT = 6,
  ALL = 7,
}

// Enums for Result Codes
export enum eResultCode {
  SUCCESS = 0,
  DB_ERROR = 1,
  NO_DATA_FOUND = 2,
  AUTHENTICATION_FAILED = 3,
  UNAUTHORIZED = 4,
  UNKNOWN = 5,
  INVALID_LOGIN_ID = 6,
  INVALID_PASSWORD = 7,
  SERVICE_ERROR = 8,
  INVALID_REQUEST = 9,
  NOT_FOUND = 10,
  NETWORK_ERRORSERVEERROR = 11,
  CREATED = 12,
  INTERNAL_SERVEERROR = 13,
  UNUSED = 14,
  MULTIPLE_RECORDS = 15,
  BAD_REQUEST = 16,
  R_DUPLICATE = 25,
  R_SHOWPRODUCTRETRYALERT = 45,
  R_SHOWOLDSERIALRNORETRYALERT = 46,
  R_SHOWOBOTHALERT = 47,
  R_SHOWL1EVALDATA = 48,
  R_SHOWEVALTEARDOWNMODAL = 50,
}

// Enums for Fetch Policy
export enum eFetchPolicy {
  CACHE_FIRST = "cache-first",
  NETWORK_ONLY = "network-only",
  CACHE_ONLY = "cache-only",
  NO_CACHE = "no-cache",
  STANDBY = "standby",
  CACHE_AND_NETWORK = "cache-and-network",
}
// Enums for HTTP Status Codes
export enum eHTTPStatusCode {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED_REQUEST = 403,
  INTERNAL_SERVER_ERROR = 500,
}

// Enums for Login Modes
export enum eLoginMode {
  PASSWORD = 1,
  OTP = 2,
}
// Enums for User Types
export enum eUserTypeId {
  ADMIN = "ADMIN",
}

// Enums for File Types
export enum eFileType {
  JPEG = ".jpeg",
  PNG = ".png",
  PDF = ".pdf",
  JPG = ".jpg",
}
// Enums for Content Types
export enum eContentType {
  IMAGE = "image/jpeg",
  PDF = "application/pdf",
  OCTETSTREAM = "application/octet-stream",
}

export enum eLANGUAGE {
  ENGLISH = "en",
  FRENCH = "fr",
  HINDI = "hi",
}

export enum eCustomDropdownType {
  SCROLLER = "SCROLLER",
  BUTTON = "BUTTON",
}

export enum ePrivileges {
  //HOME MODULE
  SCANSERIALNO = "SCANSERIALNO",
  ASSIGNCRATE = "ASSIGNCRATE",
  VIEWSCANHISTORY = "VIEWSCANHISTORY",
  VIEWINCOMINGSCAN = "VIEWINCOMINGSCAN",

  //FILE MANAGEMENT MODULE
  VIEWUPLOADEDFILES = "VIEWUPLOADEDFILES",
  UPLOADWARRANTYFILE = "UPLOADWARRANTYFILE",
  DELETEUPLOADEDFILE = "DELETEUPLOADEDFILE",

  //PRODUCTS MODULE
  // VIEWPRODUCTS = "VIEWPRODUCTS",
  // ADDPRODUCT = "ADDPRODUCT",
  // EDITPRODUCT = "EDITPRODUCT",
  // DELETEPRODUCT = "DELETEPRODUCT",

  // LEVEL 1 SCAN MODULE
  PERFORMLEVEL1SCAN = "PERFORMLEVEL1SCAN",
  // LEVEL 1 SCAN MODULE
  PERFORMLEVEL2SCAN = "PERFORMLEVEL2SCAN",
  VIEWSUMMARY = "VIEWSUMMARY",
  VIEWTIMELINE = "VIEWTIMELINE",

  // OVERALL LIST MODULE
  VIEWNOTSCANNED = "VIEWNOTSCANNED",
  VIEWWAITINGEVAL = "VIEWWAITINGEVAL",
  VIEWEVALL1LIST = "VIEWEVALL1LIST",
  VIEWEVALL2LIST = "VIEWEVALL2LIST",
  VIEWNOFAULTLIST = "VIEWNOFAULTLIST",
  VIEWTEARDOWNLIST = "VIEWTEARDOWNLIST",
  // PRODUCT MODULE
  ADDEDITPRODUCT = "ADDEDITPRODUCT",
  DELETEPRODUCT = "DELETEPRODUCT",

  // PASSWORD MANAGER
  UPDATEMOVETODRAFTPASSWORD = "UPDATEMOVETODRAFTPASSWORD",

  // FAULT CATEGORY
  ADDEDITFAULTCATEGORY = "ADDEDITFAULTCATEGORY",
  DELETEFAULTCATEGORY = "DELETEFAULTCATEGORY",

  // STATOR USED CATEGORY
  ADDEDITSTATORUSED = "ADDEDITSTATORUSED",
  DELETESTATORUSED = "DELETESTATORUSED",
  UPLOADDEFECTLOGBOOK = "UPLOADDEFECTLOGBOOK",

  // ################################ PREVIOUS ONES #######################

  // DASHBOARD MODULE
  VIEWDASHBOARD = "VIEWDASHBOARD",
  // CUSTOMER MODULE
  VIEWCUSTOMER = "VIEWCUSTOMER",
  ADDCUSTOMERS = "ADDCUSTOMERS",
  EDITCUSTOMERS = "EDITCUSTOMERS",
  DELETECUSTOMERS = "DELETECUSTOMERS",
  EDITCUSTCODE = "EDITCUSTCODE",
  // EDITDAYSTARTEND = "EDITDAYSTARTEND",

  // SERVICE PARTNER MODULE
  // ADDPARTNERS = "ADDPARTNERS",
  // EDITPARTNERS = "EDITPARTNERS",
  // DELETEPARTNERS = "CHANGEPARTNERSTATUS",
  // VIEWSERVICEPARTNER = "VIEWSERVICEPARTNER",
  // BULKUPLOADENGINEERS = "BULKUPLOADENGINEERS",
  // MAPCUSTPARTNER = "MAPCUSTPARTNER",
  // MAPDEALERENGG = "MAPDEALERENGG",

  // DEALER MODULE
  // VIEWDEALERS = "VIEWDEALERS",
  // VERIFYADL = "VERIFYADL",
  // ADDDEALERS = "ADDDEALERS",
  // EDITDEALERS = "EDITDEALERS",
  // DELETEDEALERS = "DELETEDEALERS",
  // BULKUPLOADDEALERS = "BULKUPLOADDEALERS",

  // SERVICE REQUEST MODULE
  // ADDSERVICEREQUEST = "ADDSERVICEREQUEST",
  // EDITREQUEST = "EDITREQUEST",
  // DELETEREQUEST = "DELETEREQUEST",
  // BULKUPLOADREQUEST = "BULKUPLOADREQUEST",
  // AMCAPPROVER = "APPROVEAMC", //const AddEditTicketAMCApproval: "/Ticket/AddEditTicketAMCApproval"
  // APPROVEWARRANTY = "APPROVEWARRANTY",
  // APPROVESPARES = "APPROVESPARES", //const AddEditSpareDependency: "/Ticket/AddEditSpareDependency"
  // REJECTSPARES = "REJECTSPARES",
  // VIEWSPARESPENDING = "VIEWSPARESPENDING",
  // REASSIGNENGINEER = "REASSIGNENGINEER",
  // SPAREDISPATCHED = "SPAREDISPATCHED",
  // SERVICEREQUESTFORWARD = "SPAREREQUESTFORWARD",
  // DELETETICKET = "DELETEREQUEST",

  // USER - CUSTOMER MODULE
  ADDEDITCUSTUSERS = "ADDEDITCUSTUSERS",
  VIEWCUSTUSERS = "VIEWCUSTUSERS",
  DELETECUSTUSERS = "DELETECUSTUSERS",

  // USER - PARTNER MODULE
  // ADDEDITPARTUSERS = "ADDEDITPARTUSERS",
  // VIEWPARTUSERS = "VIEWPARTUSERS",
  // DELETEPARTUSERS = "DELETEPARTUSERS",

  // USER - IDEX MODULE
  ADDEDITIDEXUSERS = "ADDEDITIDEXUSERS",
  VIEWIDEXUSERS = "VIEWIDEXUSERS",
  DELETEIDEXUSERS = "DELETEIDEXUSERS",

  ADDUSERS = "ADDUSERS",
  ADDROLES = "ADDROLES",
  EDITROLES = "EDITROLES",

  // CONFIGURATION - STATUS REASON MODULE
  // VIEWSTATUSREASON = "VIEWSTATUSREASON",
  // ADDSTATUSREASON = "ADDSTATUSREASON",
  // EDITSTATUSREASON = "EDITSTATUSREASON",
  // DELETESTATUSREASON = "DELETESTATUSREASON",

  // CONFIGURATION - CONFIG GROUP MODULE
  // VIEWCONFIGGROUP = "VIEWCONFIGGROUP",
  // ADDCONFIGGROUP = "ADDCONFIGGROUP",
  // EDITCONFIGGROUP = "EDITCONFIGGROUP",
  // DELETECONFIGGROUP = "DELETECONFIGGROUP",

  // CONFIGURATION - CONFIG PARAM MODULE
  // VIEWCONFIGPARAM = "VIEWCONFIGPARAM",
  // ADDCONFIGPARAM = "ADDCONFIGPARAM",
  // EDITCONFIGPARAM = "EDITCONFIGPARAM",
  // DELETECONFIGPARAM = "DELETECONFIGPARAM",

  // CONFIGURATION - CONFIG CATEGORY MODULE
  // VIEWCONFIGCATEGORY = "VIEWCONFIGCATEGORY",
  // ADDCONFIGCATEGORY = "ADDCONFIGCATEGORY",
  // EDITCONFIGCATEGORY = "EDITCONFIGCATEGORY",
  // DELETECONFIGCATEGORY = "DELETECONFIGCATEGORY",

  // CONFIGURATION - STATE CONF MODULE
  // VIEWSTATECONFIGRATION = "VIEWSTATECONFIGURATION",
  // UPDATEALIAS = "UPDATEALIAS",

  // CONFIGURATION - CONFIG SPARE MODULE
  // VIEWCONFIGSPARE = "VIEWCONFIGSPARE",
  // ADDCONFIGSPARE = "ADDCONFIGSPARE",
  // EDITCONFIGSPARE = "EDITCONFIGSPARE",
  // DELETECONFIGSPARE = "DELETECONFIGSPARE",

  // CONFIGURATION - CONFIG PRODUCT LIST
  // VIEWCONFIGPRODUCT = "VIEWCONFIGPRODUCT",
  // ADDCONFIGPRODUCT = "ADDCONFIGPRODUCT",
  // EDITCONFIGPRODUCT = "EDITCONFIGPRODUCT",
  // DELETECONFIGPRODUCT = "DELETECONFIGPRODUCT",

  //  REPORTS - REPORT FORM
  VIEWREPORTLIST = "VIEWREPORTS",
  DOWNLOADSLAREPORT = "DOWNLOADSLAREPORT",
  DOWNLOADSERVICEREPORT = "DOWNLOADSERVICEREPORT",
  DOWNLOADINSTALLATIONREPORT = "DOWNLOADINSTALLATIONREPORT",
  DOWNLOADYEARLYDEALERREPORT = "DOWNLOADYEARLYDEALERREPORT",
  DOWNLOADDEALERACTIVEASSETREPORT = "DOWNLOADDEALERACTIVEASSETREPORT",
  REPORTDOWNLOAD = "REPORTDOWNLOAD",
  DOWNLOADINSTALLCOSTREPORT = "DOWNLOADINSTALLCOSTREPORT",
  DOWNLOADAMCSUMMARYREPORT = "DOWNLOADAMCSUMMARYREPORT",
  APPROVEAMCSUMMARYREPORT = "APPROVEAMCSUMMARYREPORT",

  // SCHEUDLE MODULE
  VIEWSCHEDULELIST = "VIEWSCHEDULELIST",
  EDITSCHEDULE = "EDITSCHEDULE",
  CREATESCHEDULE = "CREATEREPORTSCHEDULE",
  DELETESCHEDULE = "DELETESCHEDULE",

  // ARCHIVE MODULE
  PERFORMARCHIVEACTION = "PERFORMARCHIVEACTION",

  // // PROJECT CALENDAR
  // VIEWCALENTRY = "VIEWCALENTRY",
  // ADDCALENTRY = "ADDCALENTRY",
  // EDITCALENTRY = "EDITCALENTRY",
  // DELETECALENTRY = "DELETECALENTRY",

  // // PRODUCT RATE MODULE
  // ADDPRODUCTRATE = "ADDPRODUCTRATE",
  // EIDTPRODUCTRATE = "EDITPRODUCTRATE",
  // VIEWPRODUCTRATE = "VIEWPRODUCTRATE",
}

export enum eRoles {
  SERVICEENGINEER = "SERVICEENGINEER",
  SERVICECORDINATOR = "SERVICECORDINATOR",
  SERVICEESCALATION = "SERVICEESCALATION",
}

export enum eENTITY {
  CUSTOMER = "CUSTOMER",
}

export enum eCONFIGCATEGORY {
  PRODUCTS = "PRODUCTS",
  FAULTCATEGORY = "FAULTCATEGORY",
  STATORUSED = "STATORUSED",
  DEFECTLOGBOOK = "DEFECTLOGBOOK",
  PASSWORDMANAGER = "PASSWORDMANAGER",
}

export enum eHOME {
  INCOMING_REQUEST = "INCOMING REQUEST",
  LEVEL_1 = "LEVEL 1",
  LEVEL_2 = "LEVEL 2",
}

export enum eREPORT {
  REPORTLIST = "REPORTLIST",
  SCHEDULELIST = "SCHEDULELIST",
  SUMMARYREPORTLIST = "SUMMARYREPORTLIST",
}

// FONT FAMILY
export enum eFONTFAMILY {
  REGULAR = "Montserrat-Regular",
  SEMIBOLD = "Montserrat-SemiBold",
  MEDIUM = "Montserrat-Medium",
}

export enum eREPORTTYPE {
  OVERALLRECORDSREPORT = 1,
  // SERVICEINSTALLATIONREPORT = 2,
  // YEARLYDEALERREPORT = 3,
  // DEALERACTIVEASSETREPORT = 4,
  // INSTALLATIONREPORT = 5,
  // INSTALLATIONCOSTREPORT = 6,
  // AMCSUMMARYREPORT = 7,
}

export enum eSCHEDULETYPE {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  ANNUAL = 4,
}

export enum eWEEKDAYS {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export const reportTypeMapping = {
  [eREPORTTYPE.OVERALLRECORDSREPORT]: "Overall Records Report",
};

export const scheduleTypeMapping = {
  [eSCHEDULETYPE.DAILY]: "DAILY",
  [eSCHEDULETYPE.ANNUAL]: "ANNUAL",
  [eSCHEDULETYPE.MONTHLY]: "MONTHLY",
  [eSCHEDULETYPE.WEEKLY]: "WEEKLY",
};

export const weekDaysMapping = {
  [eWEEKDAYS.SUNDAY]: "SUNDAY",
  [eWEEKDAYS.MONDAY]: "MONDAY",
  [eWEEKDAYS.TUESDAY]: "TUESDAY",
  [eWEEKDAYS.WEDNESDAY]: "WEDNESDAY",
  [eWEEKDAYS.THURSDAY]: "THURSDAY",
  [eWEEKDAYS.FRIDAY]: "FRIDAY",
  [eWEEKDAYS.SATURDAY]: "SATURDAY",
};

export enum eMONTHMAPPING {
  STARTOFMONTH = 1,
  MIDOFMONTH = 15,
  ENDOFMONTH = 31,
}

export const monthMapping = {
  [eMONTHMAPPING.STARTOFMONTH]: "Start of Month",
  [eMONTHMAPPING.MIDOFMONTH]: "Mid of Month",
  [eMONTHMAPPING.ENDOFMONTH]: "End of Month",
};

export const MONTHS = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

export const QUARTERS = {
  Q1: 1,
  Q2: 2,
  Q3: 3,
  Q4: 4,
};

export const REPORTDURATION = {
  MONTH: 1,
  QUARTER: 2,
  YEAR: 3,
};

export const APPROACH = {
  APPROACH1: 1,
  APPROACH2: 2,
};

export enum eEVAL_L1_IMAGES {
  RUST_IN_CONNECTOR = 1,
  VISUAL_INSPECTION = 2,
  CARBON_RESIDUE = 3,
}

export enum eEVAL_L1_WORKFLOW {
  DRAFT = 1,
  SUBMITTED = 2,
}
export enum eARCHIVESTATUS {
  NOT_ARCHIVED = 0,
  ARCHIVED = 1,
}

export enum eREGIONS {
  AMERICA = "AMERICA",
  INDIA = "INDIA",
  UTC = "UTC",
}

export enum eDATE_FORMAT {
  DD_MM_YYYY = "dd/MM/yyyy",
  MM_DD_YYYY = "MM/dd/yyyy",
  DD_MMM_YYYY = "dd-MMM-yyyy",
}
